module.exports = __webpack_public_path__ + "static/img/devices__hovered.488f1a8.svg";